import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import CalendarEventListing from "./CalendarEventListing";
import CalendarEventCreate from "./CalendarEventCreate";
import { CalendarEventEdit } from "./CalendarEventEdit";

export const CalendarEventAdmin = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route
                exact
                path={`${path}`}
                render={() => {
                    return <CalendarEventListing path={path} />;
                }}
            />
            <Route
                exact
                path={`${path}/create`}
                render={() => {
                    return <CalendarEventCreate path={path} />;
                }}
            />
            <Route
                exact
                path={`${path}/edit/:uuid`}
                render={(props) => {
                    const {
                        match: {
                            params: { uuid },
                        },
                    } = props;
                    return <CalendarEventEdit path={path} uuid={uuid} />;
                }}
            />
        </Switch>
    );
};

export default CalendarEventAdmin;
